<!--
 * @Description  : 文件下载中间页
 * @Author       : zhanglei
 * @Date         : 2025-07-17 14:10:06
 * @LastEditors  : zhanglei
 * @LastEditTime : 2025-07-17 17:35:31
 * @FilePath     : \ngs_platform_manage_admin\src\views\library-server\download-page.vue
-->
<template>
	<div class="download-page"></div>
</template>

<script>
export default {
	mounted() {
		this.downloadFile()
	},
	methods: {
		downloadFile() {
			let filePath = this.$route.query.path
			let fileName = this.$route.query.name
			// 使用Blob方法强制指定文件名
			this.$downloadFile(filePath + fileName, fileName)
		}
	}
}
</script>
